module.exports = __webpack_public_path__ + "static/img/050201.3c1a392b.png";